import axiosInstance from "../axiosInstance"
import type {
  CompanyResponseDto,
  UpdateCompanyDto,
  CompanyListParams,
  AllocateCreditsDto,
  AllocateCreditsResponseDto,
} from "../types/company.types"

/**
 * Company API Client
 * Direct API calls using axios instance
 */
export const companyClient = {
  // Get company by slug
  getCompanyBySlug: (slug: string): Promise<CompanyResponseDto> => {
    return axiosInstance.get(`/companies/${slug}`)
  },

  // List companies (Admin only, optional search by name)
  // Returns CompanyResponseDto[] directly (array, not paginated)
  getCompanies: (params?: CompanyListParams): Promise<CompanyResponseDto[]> => {
    // Filter out undefined values to avoid sending them to the API
    const apiParams: Record<string, string> = {}
    
    if (params?.search !== undefined && params.search !== "") {
      apiParams.search = params.search
    }
    
    return axiosInstance.get("/companies/admin", { params: apiParams })
  },

  // Update company by slug (Admin: only verified, Owner: company & contact fields)
  updateCompany: (slug: string, data: UpdateCompanyDto): Promise<CompanyResponseDto> => {
    return axiosInstance.put(`/companies/${slug}`, data)
  },

  // Allocate credits and/or ad quotas to a company (Admin only)
  allocateCredits: (
    slug: string,
    data: AllocateCreditsDto
  ): Promise<AllocateCreditsResponseDto> => {
    return axiosInstance.post(`/companies/${slug}/allocate-credits`, data)
  },
}

